import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** The check-mailing partner's ceiling for a bank account number (SD-8201). */
export const ACCOUNT_NUMBER_MAX_LENGTH = 17;

/**
 * Reject a bank account number the check-mailing partner will refuse — anything but digits — at the
 * field, before submit (SD-8201).
 *
 * The partner rejects a value with spaces or dashes and echoes it back in its error, so an account
 * number typed as printed on a statement ("1234 5678 9012") used to round-trip to the partner, come
 * back as an error-level Sentry event (CORE-1A5), and put the full account number into our logs. The
 * same pattern runs server-side in core's `CreateLobAccountRequest`; this one is what the admin sees.
 *
 * Empty values are left to `Validators.required` and over-long ones to `Validators.maxLength`, so one
 * mistake produces one message.
 */
export function accountNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value === null || value === undefined || value === '') {
            return null;
        }

        return /^\d+$/.test(value.toString()) ? null : { invalidAccountNumberFormat: true };
    };
}
